import { FShallowGraph } from '../types/node.js';

import { migration_1_0_0 } from './migration-v1.0.0.js';
import { migration_2_0_0 } from './migration-v2.0.0.js';
import { migration_3_0_0 } from './migration-v3.0.0.js';
import { migration_4_0_0 } from './migration-v4.0.0.js';
import { migration_4_1_0 } from './migration-v4.1.0.js';

const migrations = [
  migration_1_0_0,
  migration_2_0_0,
  migration_3_0_0,
  migration_4_0_0,
  migration_4_1_0,
];
/**
 * Migrate the graph state to the latest version
 */
export const migrateGraph = (state: any = []): FShallowGraph => {
  let newState: any = typeof state === 'string' ? JSON.parse(state) : state;
  migrations.forEach(({ check, migrate, version }) => {
    if (check(newState)) {
      console.info(`Migrating graph state to version ${version}`);
      try {
        newState = migrate(newState);
      } catch (ex: unknown) {
        throw new Error(
          `Error migrating graph state to version ${version}: ${(ex as Error).message}`
        );
      }
    }
  });

  return newState;
};
